import styled from 'styled-components'

const GlancePopoverContent = styled.div`
  ul {
    padding-left: 20px;
  }
`

export default GlancePopoverContent
